import { Company } from "./company";

export class Location {
  id = 0;
  name = '';
  address = '';
  address_1 = '';
  address_2 = '';
  address_3 = '';
  address_4 = '';
  postcode = '';
  contact = '';
  contact_Name = '';
  contact_Phone = '';
  contact_Email = '';
  telephone = '';
  expired = false;
  email = '';
  contract_No = '';
  miles_Rate: number = 0;
  standard_Rate: number = 0;
  overtime_Rate_1: number = 0;
  overtime_Rate_2: number = 0;

  service_Interval = 6;
  hourly_Rate = 0;
  miles = 0;
  companyId = '';

  company: Company;

  is_edit: Boolean = false;
}
